import { createMuiTheme } from '@material-ui/core/styles'
import purple from '@material-ui/core/colors/purple'
import deepPurple from '@material-ui/core/colors/deepPurple'
import lightBlue from '@material-ui/core/colors/lightBlue'

const primary = {
  main: '#4A2375'
}
const secondary = {
  main: lightBlue[500]
}
const gradientColors = {
  blue: '#0978FD',
  green: '#76E50A',
  grey: '#757575'
}
const pink = {
  main: '#EB2E6B'
}

const royal = {
  main: '#1AA3FF'
}

export default createMuiTheme({
  palette: {
    primary,
    secondary,
    background: {
      default: '#F1F1F1'
    },
    gradientColors,
    royal,
    pink
  },
  typography: {
    useNextVariants: true,
    body1: {
      fontFamily: ['Roboto', 'sans-serif'].join(','),
      fontSize: 16,
      lineHeight: '21px'
    },
    h2: {
      fontFamily: ['Poppins', 'sans-serif'].join(','),
      fontSize: 24,
      fontWeight: 800,
      lineHeight: '30px'
    },
    h3: {
      fontFamily: ['Poppins', 'sans-serif'].join(','),
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '24px'
    },
    h6: {
      fontFamily: ['Oswald', 'sans-serif'].join(',')
    },
    h5: {
      fontFamily: ['Oswald', 'sans-serif'].join(',')
    },
    subtitle1: {
      fontFamily: ['Oswald', 'sans-serif'].join(','),
      fontWeight: 300
    }
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        background: `linear-gradient(to right, ${deepPurple[900]} 0%, ${purple[800]} 50%, ${deepPurple[900]} 100%)`
      }
    },
    MuiButton: {
      root: {
        paddingTop: [0, '!important'],
        paddingBottom: [0, '!important']
      },
      // Name of the styleSheet
      containedPrimary: {
        // Name of the rule
        background: `linear-gradient(45deg, ${purple[800]} 30%, ${deepPurple[900]} 90%)`,
        color: 'white'
      },
      containedSecondary: {
        background: lightBlue[500],
        color: '#fff'
      },
      contained: {
        background: `linear-gradient(45deg, white 30%, #e0e0e0 90%)`,
        boxShadow: ['none', '!important'],
        '&:hover': {
          boxShadow: ['none', '!important']
        },
        height: 36,
        minWidth: 115
      },
      containedSizeLarge: {
        padding: '8px 32px',
        height: 75,
        borderRadius: 37.5,
        fontSize: 36
      },
      outlined: {
        border: '2px solid white'
      }
    },
    MuiIconButton: {
      colorInherit: {
        '&$disabled': {
          color: 'inherit',
          opacity: 0.26
        }
      }
    },
    MuiFab: {
      secondary: {
        color: 'white'
      }
    },
    MuiBadge: {
      colorSecondary: {
        color: '#fff'
      }
    },
    MuiModal: {
      root: {
        fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(',')
      }
    },
    MuiLinearProgress: {
      root: {
        height: 12
      },
      colorSecondary: {
        backgroundColor: 'rgba(255,255,255, 0.4)'
      },
      barColorSecondary: {
        backgroundColor: '#fff'
      }
    },
    MuiDialog: {
      paper: {
        width: '100%'
        // height: '50%'
      }
    },
    MuiMenuItem: {
      root: {
        fontFamily: ['Poppins', 'sans-serif'].join(',')
      }
    },
    MuiSpeedDialAction: {
      staticTooltipLabel: {
        backgroundColor: 'transparent',
        whiteSpace: 'nowrap',
        boxShadow: 'none',
        color: '#fff',
        fontSize: '0.8rem',
        marginRight: [0, '!important']
      },
      fab: {
        width: 'auto',
        padding: '0 16px',
        borderRadius: 20,
        margin: '8px 0'
      }
    },
    MuiSpeedDial: {
      root: {
        alignItems: 'flex-end'
      },
      fab: {
        width: 'auto',
        borderRadius: 28,
        padding: '0 24px'
      },
      directionUp: {
        '& $actions': {
          flexDirection: 'column',
          alignItems: 'flex-end'
        }
      }
    },
    MuiPopover: {
      paper: {
        padding: 16
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/themes/main.js